import { Vue, Component, Prop } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import { ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import PreformattedEditor from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor/preformatted-editor.vue'
import { preformattedAdditionalReportServices } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted-additional-report.service'

@Component({
    components: {
        PreformattedEditor
    }
})
export default class LocalPreformattedModalAdditionalReport extends Vue {
    @Prop() readonly selectedRow!: Nullable<ConfigurationPreformattedResponse>
    @Prop() readonly broadcastChannelPostMessageFunction!: Function

    get preformattedId(): number {
        return this.selectedRow?.id!
    }

    get laboratoryId(): number {
        return this.selectedRow?.laboratory?.labId!
    }

    get actionTitle(): string {
        return this.$t('configuration.modal.preformated.additionalReport').toString()
    }

    get service(): typeof preformattedAdditionalReportServices {
        return preformattedAdditionalReportServices
    }
}
